import { backgroundOrange, blue, blueDark, darkOrange, orange } from '@/theme/colors'
import { contentShell } from '@/theme/layout'
import styled from 'styled-components'

/* Full-bleed band: background/shadow/border span the viewport; the horizontal
   gutter lives on HeaderContent (the shared contentShell) so the brand lines up
   with the page content below. Vertical padding stays here for the bar height. */
export const HeaderContainer = styled.header`
	background: ${backgroundOrange};
	padding: 1rem 0;
	box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
	border-bottom: 1px solid #e1e5e9;

	@media (max-width: 600px) {
		padding: 0.625rem 0;
	}
`

export const HeaderContent = styled.div`
	${contentShell}
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 0.5rem;
`

// The brand lockup is the shared @components/BrandMark atom (same as the
// public SiteHeader) — no local logo styles.

export const Nav = styled.nav`
	display: flex;
	gap: 2rem;
`

export const NavLink = styled.a`
	color: white;
	text-decoration: none;
	font-weight: 500;
	padding: 0.5rem 1rem;
	border-radius: 8px;
	transition: all 0.3s ease;

	&:hover {
		background: rgba(255, 255, 255, 0.2);
		transform: translateY(-2px);
	}
`

export const HeaderActions = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;

	@media (max-width: 600px) {
		gap: 0.375rem;
	}
`

export const BackButton = styled.button`
	background: transparent;
	color: #495057;
	border: 1px solid transparent;
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	white-space: nowrap;

	&:hover {
		color: #212529;
	}

	@media (max-width: 600px) {
		padding: 0.4rem 0.6rem;
		font-size: 0.8rem;
	}
`

export const MyTripsButton = styled.button`
	background: transparent;
	color: ${orange};
	border: 1px solid transparent;
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 0.5rem;
	white-space: nowrap;

	&:hover {
		color: ${darkOrange};
	}

	@media (max-width: 600px) {
		padding: 0.45rem 0.55rem;
		font-size: 0.8rem;
		gap: 0.3rem;
		border-radius: 6px;

		span {
			display: none;
		}
	}
`

export const MyProfileButton = styled.button`
	background: transparent;
	color: ${orange};
	border: 1px solid transparent;
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 0.5rem;
	white-space: nowrap;

	&:hover {
		color: ${darkOrange};
	}

	@media (max-width: 600px) {
		padding: 0.45rem 0.55rem;
		font-size: 0.8rem;
		gap: 0.3rem;
		border-radius: 6px;

		span {
			display: none;
		}
	}
`

export const AdminButton = styled.button`
	background: transparent;
	color: ${blue};
	border: 1px solid transparent;
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	white-space: nowrap;

	&:hover {
		color: ${blueDark};
	}

	@media (max-width: 600px) {
		padding: 0.45rem 0.6rem;
		font-size: 0.8rem;
		border-radius: 6px;
	}
`

export const LogoutButton = styled.button`
	background: transparent;
	color: #dc3545;
	border: 1px solid transparent;
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	white-space: nowrap;

	&:hover {
		color: #c82333;
	}

	@media (max-width: 600px) {
		padding: 0.45rem 0.6rem;
		font-size: 0.8rem;
		border-radius: 6px;
	}
`
